const getFreeSpots = (
  timeStr,
  date,
  originalFreeSpots,
  reservedSpots = [],
  event
) => {
  const d = new Date(date.getTime());
  // tähän if joka vähentää varauksista poikkeus määrän
  if (!reservedSpots.length || !date) return originalFreeSpots;
  const parts = timeStr.split(':');
  // + 3 was a quick fix for time zone offset not aligning with times in database (GMT+0300 Eastern European Summer Time)
  d.setHours(parseInt(parts[0]) + 3, parseInt(parts[1]), 0, 0);
  const delta = Math.round(d.getTime() / 1000);
  const spot = reservedSpots.find((s) => s.slot === delta && s.event === event);
  if (spot) {
    return originalFreeSpots - spot.bookings;
  }
  return originalFreeSpots;
};
export default getFreeSpots;
